import { render, staticRenderFns } from "./MenuMode.vue?vue&type=template&id=064c40a2&"
import script from "./MenuMode.vue?vue&type=script&lang=js&"
export * from "./MenuMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports